<template>
  <ClientOnly>
    <ul
      v-if="cardData && !isLoading"
      :class="{ 'grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-3': true }"
    >
      <slot name="cards" />
    </ul>
  </ClientOnly>
</template>

<script setup lang="ts">
import type { CardBlogResult } from '~/sanity/types';

defineProps({
  cardData: {
    type: Object as PropType<Array<NonNullable<CardBlogResult>>>,
    required: true,
  },
  isLoading: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
});
</script>
